var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftYellow2X4Af06303Da718A581De65B81C9546Dd312411B6A778Edbecbcc2B999D94D60E3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "423px",
    height: "577px",
    viewBox: "0 0 423 577",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hero-BG-color tile-2@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C314",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC3832",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1176.95552,-127.322185 L1674.40011,-127.322185 C1692.23049,-127.322185 1698.69621,-125.465673 1705.21473,-121.979531 C1711.73325,-118.493389 1716.84902,-113.377618 1720.33516,-106.859099 C1723.8213,-100.340581 1725.67781,-93.8748562 1725.67781,-76.0444814 L1725.67781,421.400111 C1725.67781,439.230485 1723.8213,445.69621 1720.33516,452.214729 C1716.84902,458.733247 1711.73325,463.849019 1705.21473,467.335161 C1698.69621,470.821302 1692.23049,472.677815 1674.40011,472.677815 L1176.95552,472.677815 C1159.12514,472.677815 1152.65942,470.821302 1146.1409,467.335161 C1139.62238,463.849019 1134.50661,458.733247 1131.02047,452.214729 C1127.53433,445.69621 1125.67781,439.230485 1125.67781,421.400111 L1125.67781,-76.0444814 C1125.67781,-93.8748562 1127.53433,-100.340581 1131.02047,-106.859099 C1134.50661,-113.377618 1139.62238,-118.493389 1146.1409,-121.979531 C1152.65942,-125.465673 1159.12514,-127.322185 1176.95552,-127.322185 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.7%",
    y: "-3.3%",
    width: "109.3%",
    height: "109.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    transform: "translate(-1017.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hero-BG-color-tile-2",
    transform: "translate(1425.677815, 172.677815) rotate(65.000000) translate(-1425.677815, -172.677815) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftYellow2X4Af06303Da718A581De65B81C9546Dd312411B6A778Edbecbcc2B999D94D60E3);
export default __webpack_public_path__ + "static/media/left-yellow@2x-4af06303da718a581de65b81c9546dd312411b6a778edbecbcc2b999d94d60e3.4aa4d0414bd42d099365fea1d5e5651a.svg";
export { ForwardRef as ReactComponent };